import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import SVG from "react-inlinesvg";
import AdSlot300x250 from "../Ads/AdSlot300x250";
import AdSlot728x90 from "../Ads/AdSlot728x90";
const SeriesMatchCarousel = dynamic(() => import("./SeriesMatchCarousel"));

const SeriesOverview = ({
  matchData = null,
  statsData = null,
  pointsData = null,
  scrolled = false,
}) => {
  const router = useRouter();
  const currentPath = router?.asPath;
  const isTestSeries = currentPath.includes("/india-tour-of-england-2025");
  const [currentStat, setCurrentStat] = useState(1);
  const [currentStatData, setCurrentStatData] = useState(
    statsData
      ? statsData?.filter((stat) => stat.statName == "Most Runs")[0]
      : null
  );
  useEffect(() => {
    if (!statsData) return;
    let tempStats = {
      1: statsData?.filter((stat) => stat.statName == "Most Runs")[0],
      2: statsData?.filter((stat) => stat.statName == "Most Wickets")[0],
      3: statsData?.filter((stat) => stat.statName == "Most 6s")[0],
      4: statsData?.filter((stat) => stat.statName == "Most 4s")[0],
      5: statsData?.filter((stat) => stat.statName == "Best Strike Rate")[0],
    };
    setCurrentStatData(tempStats[currentStat]);
  }, [currentStat, statsData]);

  const statsMenu = [
    { statName: "Most Runs" },
    { statName: "Most Wickets" },
    { statName: "Most 6s" },
    { statName: "Most 4s" },
    { statName: "Best Strike Rate" },
  ];

  const asia_cup_teams = [
    {
      teamName: "India",
      teamLogo:
        "https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/4.png",
      players: "15",
    },
    {
      teamName: "Pakistan",
      teamLogo:
        "https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/6.png",
      players: "15",
    },
    {
      teamName: "Sri Lanka",
      teamLogo:
        "https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/8.png",
      players: "15",
    },
    {
      teamName: "Bangladesh",
      teamLogo:
        "https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/2.png",
      players: "15",
    },
    {
      teamName: "Afghanistan",
      teamLogo:
        "https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/1188.png",
      players: "15",
    },
    {
      teamName: "Hong Kong",
      teamLogo:
        "https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/19.png",
      players: "15",
    },
    {
      teamName: "Oman",
      teamLogo:
        "https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/28.png",
      players: "15",
    },
    {
      teamName: "United Arab Emirates",
      teamLogo:
        "https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/21.png",
      players: "15",
    },
  ];
  const scrollable = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [allowRight, setAllowRight] = useState(true);
  const [allowLeft, setAllowLeft] = useState(false);
  const [matches, setMatches] = useState(asia_cup_teams);

  const handleScrollLeft = () => {
    const scrollBy = scrollable.current.scrollWidth / matches?.length + 1.5;
    const newPosition = Math.max(scrollPosition - scrollBy, 0); // Limit to min 0
    scrollable.current.scrollLeft = newPosition;
    setScrollPosition(newPosition);
  };

  const handleScrollRight = () => {
    const scrollBy = scrollable.current.scrollWidth / matches?.length + 1.5;
    const contentWidth = scrollable.current.scrollWidth;
    const containerWidth = scrollable.current.clientWidth;
    const maxScroll = contentWidth - containerWidth;
    const newPosition = Math.min(scrollPosition + scrollBy, maxScroll); // Limit to max scroll

    scrollable.current.scrollLeft = newPosition;
    setScrollPosition(newPosition);
  };

  const checkScroll = () => {
    const contentWidth = scrollable.current.scrollWidth;
    const containerWidth = scrollable.current.clientWidth;
    const isAtEnd =
      scrollable.current.scrollLeft === contentWidth - containerWidth;
    const isAtStart = scrollable.current.scrollLeft === 0;
    setAllowRight(!isAtEnd);
    setAllowLeft(!isAtStart);
  };
  useEffect(() => {
    scrollable?.current?.addEventListener("scroll", checkScroll);
    return () => {
      scrollable?.current?.removeEventListener("scroll", checkScroll);
    };
  }, [scrollable]);
console.log("pointsData",pointsData)
  return (
    <div className="w-full">
      <h2 className="text-lg font-semibold mb-2">Series Info</h2>

      {/* general info card  */}
      {isTestSeries ? (
        <div className="rounded-lg border border-gray-300 flex flex-col items-start text-sm mb-8">
          <div className="w-full flex flex-col border-b p-3">
            <span className="mb-2 text-gray-500">League</span>
            <span className="">India tour of England 2025</span>
          </div>
          <div className="w-full flex items-center gap-2 p-3 border-b">
            <SVG src="/assets/icons/svg/calendar2.svg" className="w-4 h-4" />
            Thu, Jun 20 - Aug 04
          </div>
        </div>
      ) : (
        <div className="rounded-lg border border-gray-300 flex flex-col items-start text-sm mb-8">
          <div className="w-full flex flex-col border-b p-3">
            <span className="mb-2 text-gray-500">League</span>
            <span className="">Asia Cup 2025</span>
          </div>
          <div className="w-full flex items-center gap-2 p-3 border-b">
            <SVG src="/assets/icons/svg/calendar2.svg" className="w-4 h-4" />
            09 Sep - 28 Sep, 2025
          </div>
        </div>
      )}

      <SeriesMatchCarousel matchData={matchData} isTestSeries={isTestSeries} />
      {/* teams  */}

      <h2 className="text-lg font-semibold">Teams</h2>
      {isTestSeries ? (
        <div className="flex items-center justify-start gap-3 mt-2 mb-8">
          <div className="p-3 w-32 flex flex-col justify-center rounded-lg border gap-3 border-gray-300">
            <img
              src={
                "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png"
              }
              alt={"teamA_logo"}
              width={52}
              height={52}
              className="mx-auto"
            />
            <span className="text-sm mx-auto">India</span>
            <span className="text-sm mx-auto -mt-2 text-[#00000080]">
              17 players
            </span>
          </div>
          <div className="p-3 w-32 flex flex-col justify-center rounded-lg border gap-3 border-gray-300">
            <img
              src={
                "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png"
              }
              alt={"teamB_logo"}
              width={52}
              height={52}
              className="mx-auto"
            />
            <span className="text-sm mx-auto">England</span>
            <span className="text-sm mx-auto -mt-2 text-[#00000080]">
              15 players
            </span>
          </div>
        </div>
      ) : (
        <div className="relative">
          <div
            ref={scrollable}
            style={{ scrollbarWidth: "none", scrollBehavior: "smooth" }}
            className="flex items-center gap-3 mt-2 mb-8 overflow-x-auto pb-2"
          >
            {allowLeft && (
              <div className="hidden md:block absolute top-[40%] -left-3 font-semibold text-xl h-full w-16">
                <SVG
                  src="/assets/icons/svg/leftArrow.svg"
                  className={`w-6 h-6 p-1 text-primary border border-gray-300 cursor-pointer rounded-full bg-white`}
                  onClick={handleScrollLeft}
                />
              </div>
            )}
            {allowRight && (
              <div className="hidden md:block absolute top-[40%] -right-14 font-semibold text-xl h-full w-16">
                <SVG
                  src="/assets/icons/svg/rightArrow2.svg"
                  className={`w-6 h-6 p-1 text-primary border border-gray-300 cursor-pointer rounded-full bg-white`}
                  onClick={handleScrollRight}
                />
              </div>
            )}
            {asia_cup_teams?.map((item) => (
              <div
                key={item.teamName}
                className="p-3 min-w-[8rem] flex flex-col justify-center rounded-lg border gap-3 border-gray-300 flex-shrink-0"
              >
                <img
                  src={item?.teamLogo}
                  alt={item?.teamName}
                  width={52}
                  height={52}
                  className="mx-auto"
                />
                <span className="text-sm mx-auto">{item?.teamName}</span>
                {/* <span className="text-sm mx-auto -mt-2 text-[#00000080]">
                  {item?.players} players
                </span> */}
              </div>
            ))}
          </div>
        </div>
      )}
      {/* asia cup points table */}
      {!isTestSeries && pointsData?.length > 0 && (
        <div className="w-full mb-8">
          <h2 className="text-lg font-semibold mb-2">Points Table</h2>

          {pointsData?.map((group, groupIndex) => (
            <div
              key={groupIndex}
              className="w-full border border-gray-300 mb-4 rounded-md overflow-hidden"
            >
              <div className="flex justify-between bg-gray-200 px-4 py-2 font-semibold text-sm border-b border-gray-300">
                <div className="w-[40%]">{`Group ${group.name} Teams`}</div>
                <div className="w-[60%] flex justify-between">
                  <div className="w-[10%] text-center">P</div>
                  <div className="w-[10%] text-center">W</div>
                  <div className="w-[10%] text-center">L</div>
                  <div className="w-[10%] text-center">D</div>
                  <div className="w-[10%] text-center">NR</div>
                  <div className="w-[20%] text-center">NRR</div>
                  <div className="w-[15%] text-center">Points</div>
                </div>
              </div>

              {group?.team?.map((item, index) => (
                <div
                  key={index}
                  className={`flex justify-between items-center px-4 py-2 text-sm ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-100"
                  } border-b last:border-b-0`}
                >
                  <div className="w-[40%] flex items-center gap-2">
                    <img
                      width={24}
                      height={24}
                      alt="point_team"
                      src={ `https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/${item?.id}.png` ||`https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/0.png`}
                      // src={`https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${item?.short_name?.toLowerCase()}1.png`}
                    />
                    <span>{item?.short_name || "NA"}</span>
                  </div>
                  <div className="w-[60%] flex justify-between text-center">
                    <div className="w-[10%]">{item?.p || 0}</div>
                    <div className="w-[10%]">{item?.w || 0}</div>
                    <div className="w-[10%]">{item?.l || 0}</div>
                    <div className="w-[10%]">{item?.d || 0}</div>
                    <div className="w-[10%]">{item?.nr || 0}</div>
                    <div className="w-[20%]">{item?.nrr || "-"}</div>
                    <div className="w-[15%]">{item?.pts || 0}</div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
      {scrolled && (
        <div className="mx-4">
          <AdSlot300x250
            divId="div-gpt-ad-1659434604998-0"
            minWidth="300px"
            minHeight="250px"
          />{" "}
        </div>
      )}

      {scrolled && (
        <AdSlot728x90
          divId="div-gpt-ad-1707804176041-2"
          minWidth="728px"
          minHeight="90px"
        />
      )}
      {currentStatData && currentStatData?.statLeaderBoard?.length ? (
        <div>
          <div className="flex justify-between mb-2 mt-8">
            <h2 className="font-semibold text-lg">Key Stats</h2>
            <a
              href={
                isTestSeries
                  ? "/sports/cricket/india-tour-of-england-2025/stats"
                  : "/sports/asia-cup-2025/stats"
              }
              className="flex items-center gap-2 text-sm"
            >
              See All
              <SVG src="/assets/icons/svg/right.svg" className="w-3 h-3" />
            </a>
          </div>
          <div
            className="flex gap-2 items-center overflow-x-scroll whitespace-nowrap"
            style={{ scrollbarWidth: "none" }}
          >
            {statsMenu.map((item, index) => {
              return (
                <button
                  key={index}
                  onClick={() => {
                    setCurrentStat(index + 1);
                  }}
                  className={`p-2 rounded-lg border border-gray-300 text-gray-500 ${
                    currentStat == index + 1
                      ? "text-white bg-primary border-primary"
                      : ""
                  }`}
                >
                  {item.statName}
                </button>
              );
            })}
          </div>
          <div className="rounded-lg border border-gray-300 mt-2 mb-8">
            {currentStatData?.statLeaderBoard?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="border-b last:border-none px-4 py-2 flex text-sm"
                >
                  <div className="flex gap-2 w-[60%] md:w-[50%] justify-start">
                    <img
                      src={`https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/players/asia-cup/${item.player_id}.jpg`}
                      onError={(e) => {
                        e.target.src =
                          "https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/0.png";
                      }}
                      alt="player_logo"
                      width={50}
                      height={50}
                      className="w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full"
                    />
                    <div className="flex flex-col gap-1">
                      <span className=" font-semibold">{item.player_name}</span>
                      <span className="flex items-center gap-2 text-gray-400">
                        {item.for_team_short_name}
                        <div className="rounded-full w-1 h-1 bg-gray-400"></div>
                        {currentStat != 2 ? "Batter" : "Bowler"}
                      </span>
                    </div>
                  </div>
                  <div className="w-[40%] md:w-[50%] text-end flex flex-col gap-1 text-sm">
                    <span className="font-semibold">
                      {currentStat == 1 && item.runs_scored + " Runs"}
                      {currentStat == 2 && item.wickets + " Wickets"}
                      {currentStat == 3 && item.sixes + " Sixes"}
                      {currentStat == 4 && item.fours + " Fours"}
                      {currentStat == 5 && item.batting_strike_rate + " SR"}
                    </span>
                    <span className="text-gray-400">
                      {currentStat !== 2 && item.innings_played + " Inns"}
                      {currentStat == 2 && item.overs + " Overs"}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SeriesOverview;
